import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _vm.unidades.length > 1
                ? _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VToolbar,
                        { attrs: { flat: "" } },
                        [
                          _c(VToolbarTitle, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "title primary--text text--darken-1 text-no-wrap mt-0",
                              },
                              [_vm._v(" FILTROS ")]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VAutocomplete, {
                        staticClass: "mx-2",
                        attrs: {
                          "item-text": _vm.getUnidadeSiglaAndNome,
                          items: _vm.unidades,
                          "search-input": _vm.searchUnidade,
                          label: "Unidade(s):",
                          placeholder: "Digite para pesquisar...",
                          multiple: "",
                          "prepend-icon": "account_balance",
                          "return-object": "",
                        },
                        on: {
                          "update:searchInput": function ($event) {
                            _vm.searchUnidade = $event
                          },
                          "update:search-input": function ($event) {
                            _vm.searchUnidade = $event
                          },
                          change: function ($event) {
                            _vm.searchUnidade = ""
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.unidades.length > 0
                              ? {
                                  key: "prepend-item",
                                  fn: function () {
                                    return [
                                      _c(
                                        VListItem,
                                        { on: { click: _vm.toggleItens } },
                                        [
                                          _c(
                                            VListItemAction,
                                            [
                                              _c(
                                                VIcon,
                                                {
                                                  attrs: {
                                                    color:
                                                      _vm.unidadesSelecionadas
                                                        .length > 0
                                                        ? "primary"
                                                        : "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(_vm.icon) + " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VListItemContent,
                                            [
                                              _c(VListItemTitle, [
                                                _vm._v("Selecionar Todas"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(VDivider, { staticClass: "mt-2" }),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _c(
                                    VChip,
                                    {
                                      staticClass: "chip--select-multi",
                                      attrs: {
                                        "input-value": data.selected,
                                        close: "",
                                        color: "primary",
                                        search: "",
                                        small: "",
                                        "text-color": "white",
                                      },
                                      on: {
                                        "click:close": function ($event) {
                                          return _vm.removeUnidade(data.item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(data.item.sigla) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.unidadesSelecionadas,
                          callback: function ($$v) {
                            _vm.unidadesSelecionadas = $$v
                          },
                          expression: "unidadesSelecionadas",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c(VSelect, {
                        staticClass: "ml-2",
                        attrs: {
                          items: _vm.situacoes,
                          label: "Situação:",
                          "prepend-icon": "filter_list",
                        },
                        model: {
                          value: _vm.filtroSituacao,
                          callback: function ($$v) {
                            _vm.filtroSituacao = $$v
                          },
                          expression: "filtroSituacao",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(VSpacer, { staticClass: "hidden-sm-and-down" }),
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c(VTextField, {
                        staticClass: "mx-4",
                        attrs: {
                          "append-icon": "search",
                          "hide-details": "",
                          label: "Pesquisar",
                          "single-line": "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VToolbar,
                    { attrs: { flat: "" } },
                    [
                      _c(VToolbarTitle, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "title primary--text text--darken-1 text-no-wrap ma-2",
                          },
                          [
                            _vm._v(
                              " COMPETÊNCIAS TÉCNICAS (" +
                                _vm._s(_vm.competencias.length) +
                                ") "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(VDataTable, {
                staticClass: "elevation-0",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.competencias,
                  search: _vm.search,
                  "item-key": "id",
                  "show-expand": "",
                  "show-select": "",
                  "single-expand": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.nomeAtual`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "p",
                            {
                              class:
                                item.unidades.length > 0
                                  ? "grey-text"
                                  : "secondary--text",
                            },
                            [_vm._v(" " + _vm._s(item.nomeAtual) + " ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: `header.data-table-select`,
                      fn: function ({ on, props }) {
                        return [
                          _c(
                            VSimpleCheckbox,
                            _vm._g(
                              _vm._b(
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.competencias.length > 0 &&
                                        (_vm.etapa === "normalizacao" ||
                                          _vm.etapa === "consolidacao") &&
                                        _vm.prazoAtual,
                                      expression:
                                        "\n              competencias.length > 0 &&\n                (etapa === 'normalizacao' || etapa === 'consolidacao') &&\n                prazoAtual\n            ",
                                    },
                                  ],
                                  attrs: {
                                    disabled:
                                      _vm.filtroSituacao ===
                                      "Competências Gerais",
                                    color: "primary",
                                  },
                                  on: { input: _vm.toggleAllCheckboxes },
                                },
                                "v-simple-checkbox",
                                props,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.data-table-select`,
                      fn: function ({ isSelected, select, item }) {
                        return [
                          _c(VSimpleCheckbox, {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  (_vm.etapa === "normalizacao" ||
                                    _vm.etapa === "consolidacao") &&
                                  _vm.prazoAtual,
                                expression:
                                  "\n              (etapa === 'normalizacao' || etapa === 'consolidacao') &&\n                prazoAtual\n            ",
                              },
                              { def: Ripple, name: "ripple", rawName: "v-ripple" },
                            ],
                            attrs: {
                              disabled: item.unidades.length === 0,
                              value: isSelected,
                              color: "primary",
                            },
                            on: {
                              input: function ($event) {
                                return select($event)
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.data-table-expand`,
                      fn: function ({ item, expand, isExpanded }) {
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            {
                                              attrs: {
                                                height: "100%",
                                                text: "",
                                                width: "100%",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return expand(!isExpanded)
                                                },
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _c(
                                              VBadge,
                                              {
                                                attrs: { right: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "badge",
                                                      fn: function () {
                                                        return [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item
                                                                  .responsabilidades
                                                                  .length
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  {
                                                    attrs: {
                                                      color: "grey lighten-0",
                                                      large: "",
                                                    },
                                                  },
                                                  [_vm._v(" settings ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Clique para exibir as responsabilidades relacionadas"
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "expanded-item",
                      fn: function ({ headers, item }) {
                        return [
                          _c(
                            "td",
                            {
                              staticClass: "justify-center",
                              attrs: { colspan: headers.length },
                            },
                            [
                              item.responsabilidades.length > 0
                                ? _c(
                                    VRow,
                                    [
                                      _c(VSpacer),
                                      _c(
                                        VCol,
                                        { attrs: { cols: "10" } },
                                        [
                                          _c(VSimpleTable, {
                                            staticClass: "elevation-0 mb-4",
                                            attrs: { dense: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "thead",
                                                        {
                                                          staticClass:
                                                            "font-weight-medium",
                                                        },
                                                        [
                                                          _c("tr", [
                                                            _c("td", [
                                                              _vm._v("Unidade"),
                                                            ]),
                                                            _c("td", [
                                                              _vm._v(
                                                                "Responsabilidade"
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "tbody",
                                                        _vm._l(
                                                          item.responsabilidades,
                                                          function (
                                                            responsabilidade
                                                          ) {
                                                            return _c(
                                                              "tr",
                                                              {
                                                                key: responsabilidade.id,
                                                              },
                                                              [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        responsabilidade
                                                                          .unidade
                                                                          .sigla
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]),
                                                                _c(
                                                                  "td",
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          responsabilidade.tituloAtual
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      VChip,
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                responsabilidade.normalizada,
                                                                              expression:
                                                                                "responsabilidade.normalizada",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "mx-2",
                                                                        attrs: {
                                                                          color:
                                                                            "secondary",
                                                                          outlined:
                                                                            "",
                                                                          small:
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Normalizada "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      VChip,
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                responsabilidade.validada,
                                                                              expression:
                                                                                "responsabilidade.validada",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "mr-2",
                                                                        attrs: {
                                                                          color:
                                                                            "purple lighten-2",
                                                                          outlined:
                                                                            "",
                                                                          small:
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Validada "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      VChip,
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                responsabilidade.consolidada,
                                                                              expression:
                                                                                "responsabilidade.consolidada",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "mr-2",
                                                                        attrs: {
                                                                          color:
                                                                            "success",
                                                                          outlined:
                                                                            "",
                                                                          small:
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Consolidada "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      VChip,
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                responsabilidade.excluida,
                                                                              expression:
                                                                                "responsabilidade.excluida",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "mb-2",
                                                                        attrs: {
                                                                          color:
                                                                            "error",
                                                                          outlined:
                                                                            "",
                                                                          small:
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Arquivada "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(VSpacer),
                                    ],
                                    1
                                  )
                                : _c(
                                    VRow,
                                    [
                                      _c(VCol, [
                                        _c(
                                          "p",
                                          { staticClass: "text-center" },
                                          [
                                            _vm._v(
                                              " Não há responsabilidades vinculadas a está competência. "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    _vm.etapa !== "validacao"
                      ? {
                          key: `item.acoes`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                VCol,
                                [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g({}, on),
                                                  [
                                                    _c(
                                                      VBtn,
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              item.unidades
                                                                .length,
                                                            expression:
                                                              "item.unidades.length",
                                                          },
                                                        ],
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          color: "secondary",
                                                          icon: "",
                                                          small: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.editItem(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v("edit"),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      !item.hasResponsabilidadeConsolidada
                                        ? _c("span", [
                                            _vm._v(
                                              "Clique no botão para editar a competência"
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "Não é permitido editar competências associadas a responsabilidades consolidadas"
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g({}, on),
                                                  [
                                                    _c(
                                                      VBtn,
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              item.unidades
                                                                .length,
                                                            expression:
                                                              "item.unidades.length",
                                                          },
                                                        ],
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          color: "error",
                                                          icon: "",
                                                          small: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.confirmDelete(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v("delete"),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      !item.hasResponsabilidadeConsolidada
                                        ? _c("span", [
                                            _vm._v(
                                              "Clique no botão para excluir a competência"
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "Não é permitido excluir competências associadas a responsabilidades consolidadas"
                                            ),
                                          ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        }
                      : null,
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.competenciasSelecionadas,
                  callback: function ($$v) {
                    _vm.competenciasSelecionadas = $$v
                  },
                  expression: "competenciasSelecionadas",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("cadastro-edicao-competencia", {
        attrs: {
          competencia: _vm.competencia,
          "is-edicao": _vm.dialogs.save.isEdicao,
          mapeamento: _vm.mapeamento,
          etapa: _vm.etapa,
          toogle: _vm.toogleSave,
          "unidades-selecionadas": _vm.unidadesSelecionadas,
          visibilidade: _vm.dialogs.save.visibilidade,
        },
        on: { hide: _vm.toogleSave },
      }),
      _c("dialog-remove", {
        attrs: {
          "confirm-action": _vm.deleteItem,
          descricao: _vm.dialogs.remove.descricao,
          "dialog-visible": _vm.dialogs.remove.visibilidade,
          "toogle-visible": _vm.toogleRemove,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }